import {
  GlobalEvents,
  SectionElement,
  defineElement,
  globalOn,
  onClick,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XS5WIYU5.js";

// src/sections/common-header/common-header.ts
var CommonHeader = class extends SectionElement {
  constructor() {
    super(...arguments);
    this.isOpenLanguage = false;
    this.openMenuHandle = null;
    this.handleKeydown = (e) => {
      if (e.key === "Escape" && this.openMenuHandle) {
        const toggle = this.menuToggles.find((t) => t.dataset.menuToggle === this.openMenuHandle);
        this.closeDesktopMenu(this.openMenuHandle);
        toggle == null ? void 0 : toggle.focus();
      }
    };
  }
  handleOpenLinkDrawer(elm) {
    var _a;
    const handle = elm.dataset.linkButton;
    if (handle == null || typeof handle === "undefined")
      return;
    (_a = this.linkDrawers.find((d) => d.key === handle)) == null ? void 0 : _a.open();
  }
  handleOpenChildLinkDrawer(elm) {
    var _a;
    const handle = elm.dataset.childLinkButton;
    if (handle == null || typeof handle === "undefined")
      return;
    (_a = this.childLinkDrawers.find((d) => d.key === handle)) == null ? void 0 : _a.open();
  }
  handleCloseLinkDrawer(elm) {
    var _a;
    const handle = elm.dataset.linkDrawerClose;
    if (handle == null || typeof handle === "undefined")
      return;
    (_a = this.linkDrawers.find((d) => d.key === handle)) == null ? void 0 : _a.close();
  }
  handleCloseChildLinkDrawer(elm) {
    var _a;
    const handle = elm.dataset.childLinkDrawerClose;
    if (handle == null || typeof handle === "undefined")
      return;
    (_a = this.childLinkDrawers.find((d) => d.key === handle)) == null ? void 0 : _a.close();
  }
  handleMenuToggleClick(elm) {
    const handle = elm.dataset.menuToggle;
    if (!handle)
      return;
    this.toggleDesktopMenu(handle, elm);
  }
  toggleDesktopMenu(handle, toggle) {
    const panel = this.menuPanels.find((p) => p.dataset.menuPanel === handle);
    const group = toggle.closest("[data-menu-group]");
    if (!panel || !group)
      return;
    const isOpen = toggle.getAttribute("aria-expanded") === "true";
    if (isOpen) {
      this.closeDesktopMenu(handle);
    } else {
      if (this.openMenuHandle && this.openMenuHandle !== handle) {
        this.closeDesktopMenu(this.openMenuHandle);
      }
      this.openDesktopMenu(handle, toggle, panel, group);
    }
  }
  openDesktopMenu(handle, toggle, panel, group) {
    var _a;
    toggle.setAttribute("aria-expanded", "true");
    panel.classList.remove("hidden");
    panel.classList.add("block");
    group.classList.add("menu-open");
    (_a = toggle.querySelector("[data-child-chevron]")) == null ? void 0 : _a.classList.add("!rotate-0");
    this.openMenuHandle = handle;
    requestAnimationFrame(() => {
      const firstFocusable = panel.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
      firstFocusable == null ? void 0 : firstFocusable.focus();
    });
  }
  closeDesktopMenu(handle) {
    var _a;
    const toggle = this.menuToggles.find((t) => t.dataset.menuToggle === handle);
    const panel = this.menuPanels.find((p) => p.dataset.menuPanel === handle);
    const group = toggle == null ? void 0 : toggle.closest("[data-menu-group]");
    if (!toggle || !panel)
      return;
    toggle.setAttribute("aria-expanded", "false");
    panel.classList.add("hidden");
    panel.classList.remove("block");
    group == null ? void 0 : group.classList.remove("menu-open");
    (_a = toggle.querySelector("[data-child-chevron]")) == null ? void 0 : _a.classList.remove("!rotate-0");
    if (this.openMenuHandle === handle) {
      this.openMenuHandle = null;
    }
  }
  showLanguageModal() {
    return __async(this, null, function* () {
      if (this.isOpenLanguage) {
        void this.closeLanguage();
      } else {
        yield this.openLanguage();
      }
    });
  }
  openLanguage() {
    return __async(this, null, function* () {
      this.languageModal.open();
      this.isOpenLanguage = true;
    });
  }
  closeLanguage() {
    return __async(this, null, function* () {
      this.languageModal.close();
      this.isOpenLanguage = false;
    });
  }
  showModal() {
    var _a;
    (_a = this.searchModal) == null ? void 0 : _a.toggle();
  }
  handleOpenCart() {
    GlobalEvents.emit("cart:open");
  }
  handleOpenMenu() {
    GlobalEvents.emit("menu:open");
  }
  open() {
    return __async(this, null, function* () {
      this.drawer.open();
    });
  }
  close() {
    return __async(this, null, function* () {
      this.drawer.close();
      this.linkDrawers.forEach((d) => {
        void d.close();
      });
      this.childLinkDrawers.forEach((d) => {
        void d.close();
      });
    });
  }
  handleMenuLinkClick() {
    void this.close();
  }
  handleScroll() {
    if (window.scrollY < window.innerHeight / 2) {
      if (!this.hasAttribute("scrolled")) {
        this.setAttribute("scrolled", "");
      }
    } else if (window.scrollY > window.innerHeight / 4) {
      if (this.hasAttribute("scrolled")) {
        this.removeAttribute("scrolled");
      }
    }
  }
  connectedCallback() {
    window == null ? void 0 : window.document.addEventListener("scroll", () => {
      this.handleScroll();
    });
    window == null ? void 0 : window.document.addEventListener("keydown", this.handleKeydown);
    this.handleScroll();
  }
  disconnectedCallback() {
    window == null ? void 0 : window.document.removeEventListener("keydown", this.handleKeydown);
  }
};
__decorateClass([
  query("[data-menu-drawer]")
], CommonHeader.prototype, "drawer", 2);
__decorateClass([
  queryAll("[data-menu-toggle]")
], CommonHeader.prototype, "menuToggles", 2);
__decorateClass([
  queryAll("[data-menu-panel]")
], CommonHeader.prototype, "menuPanels", 2);
__decorateClass([
  queryAll("[data-menu-group]")
], CommonHeader.prototype, "menuGroups", 2);
__decorateClass([
  query("[search-modal]")
], CommonHeader.prototype, "searchModal", 2);
__decorateClass([
  query("[language-modal]")
], CommonHeader.prototype, "languageModal", 2);
__decorateClass([
  queryAll("[data-link-drawer]")
], CommonHeader.prototype, "linkDrawers", 2);
__decorateClass([
  queryAll("[data-child-link-drawer]")
], CommonHeader.prototype, "childLinkDrawers", 2);
__decorateClass([
  onClick("[data-link-button]")
], CommonHeader.prototype, "handleOpenLinkDrawer", 1);
__decorateClass([
  onClick("[data-child-link-button]")
], CommonHeader.prototype, "handleOpenChildLinkDrawer", 1);
__decorateClass([
  onClick("[data-link-drawer-close]")
], CommonHeader.prototype, "handleCloseLinkDrawer", 1);
__decorateClass([
  onClick("[data-child-link-drawer-close]")
], CommonHeader.prototype, "handleCloseChildLinkDrawer", 1);
__decorateClass([
  onClick("[data-menu-toggle]")
], CommonHeader.prototype, "handleMenuToggleClick", 1);
__decorateClass([
  onClick("[data-language-open]")
], CommonHeader.prototype, "showLanguageModal", 1);
__decorateClass([
  onClick("[data-modal-search]")
], CommonHeader.prototype, "showModal", 1);
__decorateClass([
  onClick("[data-open-cart]")
], CommonHeader.prototype, "handleOpenCart", 1);
__decorateClass([
  onClick("[data-open-menu]")
], CommonHeader.prototype, "handleOpenMenu", 1);
__decorateClass([
  query("[data-additional-text]")
], CommonHeader.prototype, "addText", 2);
__decorateClass([
  query("[data-menu-row]")
], CommonHeader.prototype, "menuRow", 2);
__decorateClass([
  query("[data-menu2-row]")
], CommonHeader.prototype, "menuRow2", 2);
__decorateClass([
  query("[data-row-container]")
], CommonHeader.prototype, "rowContainer", 2);
__decorateClass([
  query("[data-shop-logo]")
], CommonHeader.prototype, "shopLogo", 2);
__decorateClass([
  query("[data-mobile-text]")
], CommonHeader.prototype, "addTextMobile", 2);
__decorateClass([
  query("[data-menu-row-mega]")
], CommonHeader.prototype, "menuRowMega", 2);
__decorateClass([
  globalOn("menu:open")
], CommonHeader.prototype, "open", 1);
__decorateClass([
  globalOn("menu:close"),
  onClick("[data-menu-close]")
], CommonHeader.prototype, "close", 1);
__decorateClass([
  onClick("[data-menu-link]")
], CommonHeader.prototype, "handleMenuLinkClick", 1);
CommonHeader = __decorateClass([
  defineElement("common-header")
], CommonHeader);
export {
  CommonHeader
};
